// extracted by mini-css-extract-plugin
export default {"collapse":"Collapsible_collapse__GdnFx","in":"Collapsible_in__mKAWV","collapseButton":"Collapsible_collapseButton__0+Cfz"};